var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconFilterUndo = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { strokeWidth: "1.5", d: "M22.1,10.4H9.9l4.9,5.8v4l2.4,1.2v-5.3L22.1,10.4z" }),
            React.createElement("g", { transform: "translate(0.448 -2.17)" },
                React.createElement("path", { d: "M2.1,7.1v7.5" }),
                React.createElement("path", { d: "M5.2,20.9c2.1,5.9,8.5,8.9,14.3,6.9c5.9-2.1,8.9-8.5,6.9-14.3c-2.1-5.9-8.4-9-14.3-6.9\n\t\tc-1.6,0.6-3,1.4-4.3,2.7l-5.8,5.4" })))));
});
export default IconFilterUndo;
//# sourceMappingURL=IconFilterUndo.js.map